module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074c0_banner_800x600.c7fd0c6c.png";